import { memo, useCallback } from 'react';
import BottomDrawerSelect from 'src/components/Inputs/BottomDrawerSelect/BottomDrawerSelect';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { ScaledOrderSizeDistribution } from 'src/stores/DriftStore/types/tradeForm';

const SIZE_DISTRIBUTION_OPTIONS: {
	label: string;
	value: ScaledOrderSizeDistribution;
}[] = [
	{ label: 'Flat', value: 'flat' },
	{ label: 'Ascending', value: 'ascending' },
	{ label: 'Descending', value: 'descending' },
];

function BottomDrawerSelectSizeDistribution() {
	const set = useDriftStore((s) => s.set);
	const selectedSizeDistribution = useDriftStore(
		(s) => s.tradeForm.scaledOrders.sizeDistribution
	);

	const handleSelect = useCallback(
		(sizeDistribution: ScaledOrderSizeDistribution) => {
			set((s) => {
				s.tradeForm.scaledOrders.sizeDistribution = sizeDistribution;
			});
		},
		[set]
	);

	return (
		<BottomDrawerSelect
			label="Distribution"
			triggerValue={selectedSizeDistribution ?? ''}
			options={SIZE_DISTRIBUTION_OPTIONS}
			onSelect={handleSelect}
			selectedValue={selectedSizeDistribution}
		/>
	);
}

export default memo(BottomDrawerSelectSizeDistribution);
